import React from "react";
import BlogDetails from "@/components/Pages/Public/BlogDetails";

const BlogDetailsPage: React.FC = () => {
  return <BlogDetails />;
};

export default BlogDetailsPage;
